import { Box3, Object3D } from 'three';
import visibleSize from './visible-size';

export const longestDimension = (obj: Object3D) => {
    const box = new Box3();
    visibleSize(obj, box);

    return Math.max(
        box.max.x - box.min.x,
        box.max.y - box.min.y,
        box.max.x - box.min.x,
    );
}
export default longestDimension;
